/**
 * FunnelHealthBadge — MA-FUNNEL-HEALTH-SCORE-013
 * 
 * Compact health score badge for funnel list tables.
 * Color-coded pill: green (healthy), blue (good), amber (at_risk), red (unhealthy).
 */

import React from 'react';

const STATUS_CONFIG = {
  healthy:   { bg: 'bg-emerald-500/15', text: 'text-emerald-400', ring: 'ring-emerald-500/25', label: 'Healthy' },
  good:      { bg: 'bg-sky-500/15',     text: 'text-sky-400',     ring: 'ring-sky-500/25',     label: 'Good' },
  at_risk:   { bg: 'bg-amber-500/15',   text: 'text-amber-400',   ring: 'ring-amber-500/25',   label: 'At Risk' },
  unhealthy: { bg: 'bg-red-500/15',     text: 'text-red-400',     ring: 'ring-red-500/25',     label: 'Unhealthy' },
};

export function FunnelHealthBadge({ score, status }) {
  if (score == null || !status) return null;
  
  const cfg = STATUS_CONFIG[status] || STATUS_CONFIG.good;
  
  return (
    <span
      data-testid="funnel-health-badge"
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-xs font-medium ring-1 ${cfg.bg} ${cfg.text} ${cfg.ring}`}
    >
      <span className="tabular-nums font-semibold">{score}</span>
      <span className="opacity-80">{cfg.label}</span>
    </span>
  );
}

export default FunnelHealthBadge;
